import { makeApiRequests } from '../helpers/api';
import { ENDPOINTS } from '../helpers/constants';

export const calculatorService = {
  getAllCalculators: async () => {
    const { response, error } = await makeApiRequests({
      endpoint: ENDPOINTS.CALCULATOR,
      method: 'GET'
    });
    return { response, error };
  },
  createCalculator: async calculator => {
    const { response, error } = await makeApiRequests({
      endpoint: ENDPOINTS.CALCULATOR,
      method: 'POST',
      requestBody: calculator
    });
    return { response, error };
  },
  updateMultiple: async requestBody => {
    const { response, error } = await makeApiRequests({
      endpoint: ENDPOINTS.CALCULATOR,
      method: 'PUT',
      requestBody
    });
    return { response, error };
  },
  deleteCalculator: async calculatorId => {
    const { response, error } = await makeApiRequests({
      endpoint: ENDPOINTS.CALCULATOR_WITH_ID(calculatorId),
      method: 'DELETE'
    });
    return { response, error };
  },
  updateCalculator: async (calculatorId, calculator) => {
    const { response, error } = await makeApiRequests({
      endpoint: ENDPOINTS.CALCULATOR_WITH_ID(calculatorId),
      method: 'PUT',
      requestBody: calculator
    });
    return { response, error };
  },
  getCategories: async reqBody => {
    const { response, error } = await makeApiRequests({
      endpoint: ENDPOINTS.CALCULATOR_CATEGORY,
      method: 'POST',
      requestBody: reqBody
    });
    return { response, error };
  },
  updateMultipleCategories: async categories => {
    const { response, error } = await makeApiRequests({
      endpoint: ENDPOINTS.CALCULATOR_CATEGORY_MULTIPLE,
      method: 'PUT',
      requestBody: categories
    });
    return { response, error };
  }
};
